module.exports = __webpack_public_path__ + "static/media/oecanthus_pellucens.aa2dbbaf.jpg";